export const SOFTLINE_FEATURE_SUBKUNDEN = 'subkunden';
export const SOFTLINE_PERMISSIONS_SUBKUNDEN = 'SUBKUNDEN';
export const SOFTLINE_MODULE_SUBKUNDEN = 'SUBKUNDEN';
